import { GeneratedDescriptionTextsDTO, HotelAmentityTextDTO } from '@bandido/shared/dtos';
import { DescriptionType, InfoLanguage } from '@bandido/shared/types';
import DOMPurify from 'dompurify';

interface HasId {
  id: number;
}

export function showTextInLanguage(texts?: { text: string; language: string }[], langToShow?: string) {
  if (texts?.length) {
    const text = texts.find(({ language }) => language === langToShow);
    if (text) {
      // if found, we return the desired text
      return text.text;
    } else {
      // if not, the first we get
      return texts[0].text;
    }
  } else {
    return '';
  }
}

export function sortById<T extends HasId>(items: T[]): T[] {
  return items.sort((a, b) => a.id - b.id);
}

export function latLongValidation(value?: string) {
  if (!value) return false;

  const regex = /^(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)$/;
  const match = value.match(regex);

  if (!match) return false;

  const lat = parseFloat(match[1]);
  const long = parseFloat(match[3]);

  if (lat < -90 || lat > 90) return false;
  if (long < -180 || long > 180) return false;

  return true;
}

export function getDescriptionByType(texts: GeneratedDescriptionTextsDTO, type: DescriptionType) {
  return {
    type,
    texts: Object.keys(texts).map((key) => ({
      text: DOMPurify.sanitize(texts[key as InfoLanguage]),
      language: key as InfoLanguage,
    })),
  };
}

export const getTextToShow = (texts?: { text: string; language: string; }[], langToShow = InfoLanguage.English) => {
  const textToShow = showTextInLanguage(texts, langToShow);
  if (textToShow) {
    return {
      translated: false,
      text: textToShow,
    };

  } else {
    return {
      translated: true,
      text: 'common.notValueFound',
    };
  }
};

export const getAmenityTooltipText = (
  systemMappingKey: string,
  texts: HotelAmentityTextDTO[],
  code: string
) => {
  if (systemMappingKey) {
    return {
      translated: true,
      text: `hotels.amenities.${systemMappingKey}`,
    };
  } else if (texts && texts.length) {
    return getTextToShow(texts);
  } else {
    return {
      translated: false,
      text: code,
    };
  }
};
